// src/components/ArrestTimer.js
import React, { useState, useEffect } from 'react';

export default function ArrestTimer({ isRunning, reset }) {
    const [seconds, setSeconds] = useState(() => {
        const savedSeconds = localStorage.getItem('arrestTimerSeconds');
        return savedSeconds ? parseInt(savedSeconds, 10) : 0;
    });

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setSeconds(prevSeconds => {
                    const newSeconds = prevSeconds + 1;
                    localStorage.setItem('arrestTimerSeconds', newSeconds);
                    return newSeconds;
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning]);

    useEffect(() => {
        setSeconds(0);
        localStorage.removeItem('arrestTimerSeconds');
    }, [reset]);

    return (
        <div className="arrest-timer">
            <h1>Arrest Timer</h1>
            <p>Time: {seconds}s</p>
        </div>
    );
}
